import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { LoginService } from '../login.service';

export interface MappingSuggestion {
    key: string;
    field: string;
    systemKey?: string;
    elementKey?: string;
    strategy: string;
    confidence: number;
    isMapped: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MappingSuggestionService {

    constructor(private http: HttpClient, private loginService: LoginService) {
    }

    suggest(headers: string[]): Promise<MappingSuggestion[]> {
        return lastValueFrom(this.http.post<MappingSuggestion[]>(
            'api/Import/SuggestTemplateMappings',
            {
                customerId: this.loginService.currentUser.customerId,
                headers: headers
            }
        ));
    }

    seedFields(): Promise<void> {
        return lastValueFrom(this.http.post<void>('api/PimFieldSynchronization/SeedFieldsNow', {}));
    }

    responseCacheSize(): Promise<number> {
        return lastValueFrom(this.http.get<{ entries: number }>(
            'api/LLMCache/ResponseCacheSize'
        )).then(r => r.entries);
    }

    clearResponseCache(): Promise<number> {
        return lastValueFrom(this.http.post<{ removed: number }>(
            'api/LLMCache/ClearResponseCache', {}
        )).then(r => r.removed);
    }

    aggregateStatistics(): Promise<void> {
        return lastValueFrom(this.http.post<void>('api/PimFieldSynchronization/AggregateStatisticsNow', {}));
    }
}
